import ResponsiveImage from "../responsive-image/ResponsiveImage";
import React, { useId } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import instrumentsImage from "../buy&rent/shop.JPG";
import enTranslations from "./invitation_en.json";
import deTranslations from "./invitation_de.json";
import "./InstrumentInvitation.css";
import "../buy&rent/PillButton.css";

const InstrumentInvitation = () => {
  const { t, i18n } = useTranslation();
  const headingId = useId();

  i18n.addResourceBundle("en", "instrumentInvitation", enTranslations, true, true);
  i18n.addResourceBundle("de", "instrumentInvitation", deTranslations, true, true);

  const language = (i18n.resolvedLanguage || i18n.language || "de").startsWith("en")
    ? "en"
    : "de";

  return (
    <section className="instrument-invitation" aria-labelledby={headingId}>
      <div className="instrument-invitation__inner">
        <ResponsiveImage sizes="(max-width: 768px) 100vw, 50vw"
          className="instrument-invitation__image"
          src={instrumentsImage}
          alt={t("instrumentInvitation:image_alt")}
          width="1250"
          height="713"
          loading="lazy"
          decoding="async"
        />
        <div className="instrument-invitation__content">
          <h2 id={headingId}>{t("instrumentInvitation:title")}</h2>
          <p>{t("instrumentInvitation:description")}</p>
          <p>{t("instrumentInvitation:visit")}</p>
          <Link
            className="buyrent-pill-btn instrument-invitation__contact focus-highlight"
            to={`/${language}/contact`}
            onClick={() => window.scrollTo(0, 0)}
          >
            {t("instrumentInvitation:contact")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default InstrumentInvitation;
